import * as Styles from "./NotFound.styles";

export const NotFoundComponent = () => {
  return <Styles.Title>404 Not Found</Styles.Title>;
};
